module.exports = __webpack_public_path__ + "img/Latex - Application1.b948f2e9.png";